import { render, staticRenderFns } from "./Produkte.vue?vue&type=template&id=31590646&scoped=true&"
import script from "./Produkte.vue?vue&type=script&lang=js&"
export * from "./Produkte.vue?vue&type=script&lang=js&"
import style0 from "./Produkte.vue?vue&type=style&index=0&id=31590646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31590646",
  null
  
)

component.options.__file = "Produkte.vue"
export default component.exports